import React from 'react';

import { useInView } from 'react-intersection-observer';
import { trackEvent, TrackingProvider } from '../tracking/Tracking';

interface UseComponentTrackingHookResponse {
  ref: (node?: Element | null) => void;
}

const useComponentTracking = (
  trackingId: string,
  skip?: boolean,
  error?: string | boolean,
  properties?: Record<string, unknown>,
  providers?: TrackingProvider[],
): UseComponentTrackingHookResponse => {
  const { ref, inView } = useInView({
    threshold: 0.5,
    initialInView: false,
    delay: 100,
  });

  React.useEffect(() => {
    if (inView) {
      trackEvent(
        'component viewed',
        {
          trackingId,
          error: error || undefined,
          ...(properties ?? {}),
        },
        { providers },
      );
    }
  }, [inView, trackingId, error]);

  React.useEffect(() => {
    if (!skip) {
      trackEvent(
        'component loaded',
        {
          trackingId,
          error: error || undefined,
          ...(properties ?? {}),
        },
        { providers },
      );
    }
  }, [skip, error, trackingId]);

  return {
    ref,
  };
};

export default useComponentTracking;
